"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6510],{

/***/ 76510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Event; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/Alert/Alert.tsx + 1 modules
var Alert = __webpack_require__(60585);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/components/Modal/Modal.tsx + 9 modules
var Modal = __webpack_require__(81579);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/Button/Button.tsx + 1 modules
var Button = __webpack_require__(83537);
// EXTERNAL MODULE: ./src/utils/material.utils.ts
var material_utils = __webpack_require__(27098);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
;// CONCATENATED MODULE: ./src/components/MyMaterials/MyMaterials.elements.tsx



var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MyMaterialselements__Wrapper",
  componentId: "sc-jszjg9-0"
})([""]);
var Materials = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MyMaterialselements__Materials",
  componentId: "sc-jszjg9-1"
})(["padding:", ";", ";margin-top:", ";"], (0,polished_esm/* rem */.hO)(15), function (prop) {
  return prop.isOpen ? "background: ".concat(prop.theme.colors.darkLight) : '';
}, (0,polished_esm/* rem */.hO)(50));
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MyMaterialselements__Header",
  componentId: "sc-jszjg9-2"
})(["display:flex;position:relative;align-items:center;justify-content:space-between;"]);
var Label = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "MyMaterialselements__Label",
  componentId: "sc-jszjg9-3"
})(["cursor:pointer;display:inline-block;margin-left:", ";"], (0,polished_esm/* rem */.hO)(30));
var ArrowIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "MyMaterialselements__ArrowIcon",
  componentId: "sc-jszjg9-4"
})(["position:absolute;left:", ";cursor:pointer;&.isOpen{transform:rotate(180deg);}svg{margin-bottom:-", ";width:", ";height:", ";path{fill:", " !important;}}"], (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(4), (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(16), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
});
var FileIcon = (0,styled_components_browser_esm/* default */.ZP)(Icon/* default */.ZP).withConfig({
  displayName: "MyMaterialselements__FileIcon",
  componentId: "sc-jszjg9-5"
})(["margin-right:", ";svg{width:", ";height:", ";}"], (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20));
var Material = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MyMaterialselements__Material",
  componentId: "sc-jszjg9-6"
})(["display:flex;align-items:center;padding-top:", ";"], (0,polished_esm/* rem */.hO)(10));
var Name = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "MyMaterialselements__Name",
  componentId: "sc-jszjg9-7"
})(["font-weight:", ";cursor:pointer;color:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/MyMaterials/MyMaterials.tsx











var MyMaterialsTemplate = function MyMaterialsTemplate(_ref) {
  var materials = _ref.materials,
      eventSlug = _ref.eventSlug;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Materials, {
      isOpen: true,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Header, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
          onClick: function onClick() {
            return setIsOpen(!isOpen);
          },
          children: isOpen ? t('material.close.all') : t('material.show.all')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowIcon, {
          onClick: function onClick() {
            return setIsOpen(!isOpen);
          },
          className: isOpen ? 'isOpen' : 'isClose',
          name: Icon/* Icons.ArrowDown */.PJ.ArrowDown
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          onClick: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
            return regenerator_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    setIsLoading(true);
                    _context.next = 3;
                    return (0,material_utils/* handleDownloadClickAsZip */.h)(materials, eventSlug);

                  case 3:
                    setIsLoading(false);

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          })),
          text: t('material.download.all'),
          isLoading: isLoading
        })]
      }), isOpen && (materials === null || materials === void 0 ? void 0 : materials.map(function (material, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Material, {
          onClick: function onClick() {
            return (0,material_utils/* handleDownloadClick */.b)(material._key, material.filename, false, material.mime_type);
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FileIcon, {
            name: Icon/* Icons.File */.PJ.File
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Name, {
            children: [t('material.label'), ": ", material.name]
          })]
        }, index);
      }))]
    })
  });
};

/* harmony default export */ var MyMaterials = (MyMaterialsTemplate);
// EXTERNAL MODULE: ./src/ui/Lecturer/Lecturer.tsx + 1 modules
var Lecturer = __webpack_require__(58596);
// EXTERNAL MODULE: ./src/ui/Package/Package.tsx + 1 modules
var Package = __webpack_require__(42420);
// EXTERNAL MODULE: ./src/ui/Tag/Tag.tsx + 1 modules
var Tag = __webpack_require__(67279);
// EXTERNAL MODULE: ./src/utils/person.utils.ts
var person_utils = __webpack_require__(19033);
// EXTERNAL MODULE: ./src/utils/time.utils.ts
var time_utils = __webpack_require__(775);
// EXTERNAL MODULE: ./src/utils/url.utils.ts
var url_utils = __webpack_require__(8333);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./src/constants/packages.ts
var constants_packages = __webpack_require__(31828);
// EXTERNAL MODULE: ./src/services/calendar.service.ts
var calendar_service = __webpack_require__(2253);
// EXTERNAL MODULE: ./src/store/ui.ts
var ui = __webpack_require__(18770);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/Event/Event.elements.tsx




var Item = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Eventelements__Item",
  componentId: "sc-wekrny-0"
})(["margin-bottom:", ";@media (min-width:", "px){display:flex;min-height:", ";}"], (0,polished_esm/* rem */.hO)(20), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(185));
var Calendar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Eventelements__Calendar",
  componentId: "sc-wekrny-1"
})(["background:", ";display:flex;flex-direction:column;padding:", " ", ";position:relative;@media (min-width:", "px){width:", ";}"], function (prop) {
  return prop.isConference ? prop.theme.colors.primaryMedium : prop.theme.colors.primaryLight;
}, (0,polished_esm/* rem */.hO)(15), (0,polished_esm/* rem */.hO)(10), theme/* breakpoints.md */.A.md, (0,polished_esm/* rem */.hO)(195));
var DateNumber = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Eventelements__DateNumber",
  componentId: "sc-wekrny-2"
})(["font-weight:", ";font-family:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.textBold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.fontSecondary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.black;
});
var DateSeparator = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Eventelements__DateSeparator",
  componentId: "sc-wekrny-3"
})(["display:inline-block;padding:0 ", ";"], (0,polished_esm/* rem */.hO)(0));
var Topic = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Eventelements__Topic",
  componentId: "sc-wekrny-4"
})(["border:1px solid ", ";padding:", ";border-radius:", ";position:relative;width:100%;@media (min-width:", "px){padding:", ";}@media (min-width:", "px){display:flex;flex-direction:column;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(16), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.md */.A.md);
var TopicPackageRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Eventelements__TopicPackageRow",
  componentId: "sc-wekrny-5"
})(["padding-bottom:", ";margin-top:", ";@media (min-width:", "px){position:absolute;right:", ";margin-top:0;top:", ";}"], (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(-5), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(25), (0,polished_esm/* rem */.hO)(55));
var TopicFirstRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Eventelements__TopicFirstRow",
  componentId: "sc-wekrny-6"
})(["display:flex;flex-direction:row;justify-content:space-between;padding-bottom:", ";.label{color:", ";font-size:", ";padding:", " ", ";font-weight:400;margin-left:", ";text-transform:uppercase;border-radius:", ";}.conferenceLabel{background:", ";}.courseLabel{background:", ";}"], (0,polished_esm/* rem */.hO)(15), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.white;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontSizes.textSmall;
}, (0,polished_esm/* rem */.hO)(4), (0,polished_esm/* rem */.hO)(12), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(16), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.black;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.dark;
});
var TopicSecondRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Eventelements__TopicSecondRow",
  componentId: "sc-wekrny-7"
})(["padding-bottom:", ";"], (0,polished_esm/* rem */.hO)(25));
var TopicThirdRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Eventelements__TopicThirdRow",
  componentId: "sc-wekrny-8"
})(["@media (min-width:", "px){display:flex;flex-direction:row;justify-content:space-between;align-items:flex-end;}"], theme/* breakpoints.sm */.A.sm);
var TopicTitle = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Eventelements__TopicTitle",
  componentId: "sc-wekrny-9"
})(["font-size:", ";line-height:", ";font-weight:", ";font-family:", ";color:", ";background:none;padding:0;border:none;cursor:pointer;text-align:left;text-decoration:none;display:inline-block;@media (min-width:", "px){width:70%;font-size:", ";line-height:", ";}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontSizes.h6;
}, (0,polished_esm/* rem */.hO)(24), function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontWeights.textBold;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fonts.fontSecondary;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.colors.black;
}, theme/* breakpoints.sm */.A.sm, function (_ref13) {
  var theme = _ref13.theme;
  return theme.fontSizes.h5;
}, (0,polished_esm/* rem */.hO)(30));
var TopicPlace = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Eventelements__TopicPlace",
  componentId: "sc-wekrny-10"
})(["padding-bottom:", ";"], (0,polished_esm/* rem */.hO)(10));
var Lecturers = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Eventelements__Lecturers",
  componentId: "sc-wekrny-11"
})(["display:flex;flex-wrap:wrap;max-width:80%;"]);
var Tags = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Eventelements__Tags",
  componentId: "sc-wekrny-12"
})(["padding:", " 0;@media (min-width:", "px){padding:0;}"], (0,polished_esm/* rem */.hO)(15), theme/* breakpoints.md */.A.md);
var FavouriteIcon = (0,styled_components_browser_esm/* default */.ZP)(IconTemplate/* IconTemplate */._).withConfig({
  displayName: "Eventelements__FavouriteIcon",
  componentId: "sc-wekrny-13"
})(["margin-right:", ";svg{width:", ";height:", ";}"], (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(14));
var FavouriteLabel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Eventelements__FavouriteLabel",
  componentId: "sc-wekrny-14"
})(["color:", ";display:none;@media (min-width:", "px){display:inline-block;}"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.grey;
}, theme/* breakpoints.sm */.A.sm);
var Favourite = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Eventelements__Favourite",
  componentId: "sc-wekrny-15"
})(["font-size:", ";display:flex;align-items:center;cursor:pointer;"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontSizes.textBase;
});
;// CONCATENATED MODULE: ./src/components/Event/Event.tsx




























var EventTemplate = function EventTemplate(_ref) {
  var _event$conference, _event$conference$_id, _event$event, _event$event$_id, _event$course, _event$course$_id, _event$event2, _event$event2$_id, _event$dates8, _event$dates8$find, _event$dates8$find$mo, _event$dates9, _event$dates9$, _event$dates9$$module, _ref3, _ref3$modules, _ref3$modules$filter, _event$dates10, _event$dates11, _event$course4, _event$conference4, _event$event6, _ref4, _ref4$filter, _ref5, _event$dates12, _event$dates12$, _ref6, _ref6$filter, _ref7, _ref7$filter, _ref8, _event$dates13, _event$dates13$, _eventDate$attachment, _event$course5, _event$conference5, _event$event7;

  var event = _ref.event,
      iKey = _ref.iKey;

  var _useTranslations = (0,useTranslation/* default */.Z)(),
      t = _useTranslations.t;

  var router = (0,next_router.useRouter)();
  var dispatch = (0,es/* useDispatch */.I0)();
  var isConference = (event === null || event === void 0 ? void 0 : (_event$conference = event.conference) === null || _event$conference === void 0 ? void 0 : (_event$conference$_id = _event$conference._id) === null || _event$conference$_id === void 0 ? void 0 : _event$conference$_id.includes('Conference')) || (event === null || event === void 0 ? void 0 : (_event$event = event.event) === null || _event$event === void 0 ? void 0 : (_event$event$_id = _event$event._id) === null || _event$event$_id === void 0 ? void 0 : _event$event$_id.includes('Conference'));
  var isCourse = (event === null || event === void 0 ? void 0 : (_event$course = event.course) === null || _event$course === void 0 ? void 0 : (_event$course$_id = _event$course._id) === null || _event$course$_id === void 0 ? void 0 : _event$course$_id.includes('Course')) || (event === null || event === void 0 ? void 0 : (_event$event2 = event.event) === null || _event$event2 === void 0 ? void 0 : (_event$event2$_id = _event$event2._id) === null || _event$event2$_id === void 0 ? void 0 : _event$event2$_id.includes('Course'));
  var isLoggedInState = (0,es/* useSelector */.v9)(function (state) {
    return state.ui.isLoggedIn;
  });

  var _useState = (0,react.useState)(null),
      eventDate = _useState[0],
      setEventDate = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isLoggedIn = _useState2[0],
      setIsLoggedIn = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      hasError = _useState3[0],
      setHasError = _useState3[1];

  var _useState4 = (0,react.useState)(event === null || event === void 0 ? void 0 : event.is_favorite),
      isFavourite = _useState4[0],
      setIsFavourite = _useState4[1];

  (0,react.useEffect)(function () {
    setIsFavourite(event === null || event === void 0 ? void 0 : event.is_favorite);
  }, [event]);
  (0,react.useEffect)(function () {
    if (event) {
      var _event$dates;

      setEventDate((router.asPath.includes(constants/* ROUTES.MY_PV_FAVOURITES */.Z6.MY_PV_FAVOURITES) ? (0,time_utils/* closestDateFrom */.b$)(event.dates) : (_event$dates = event.dates) === null || _event$dates === void 0 ? void 0 : _event$dates[0]) || event.eventDate);
    }
  }, []);
  (0,react.useEffect)(function () {
    setIsLoggedIn(isLoggedInState);
  }, [isLoggedInState]);

  var handleOnFavoriteClick = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _event$course2, _event$conference2, _event$event3, eventKey;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setHasError(false);
              eventKey = (event === null || event === void 0 ? void 0 : (_event$course2 = event.course) === null || _event$course2 === void 0 ? void 0 : _event$course2._key) || (event === null || event === void 0 ? void 0 : (_event$conference2 = event.conference) === null || _event$conference2 === void 0 ? void 0 : _event$conference2._key) || (event === null || event === void 0 ? void 0 : (_event$event3 = event.event) === null || _event$event3 === void 0 ? void 0 : _event$event3._key);

              if (isLoggedIn) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", dispatch((0,ui/* openModalType */.$X)({
                type: Modal/* ModalTypes.LOGIN */.Q.LOGIN
              })));

            case 5:
              if (!isFavourite) {
                _context.next = 15;
                break;
              }

              if (!isCourse) {
                _context.next = 11;
                break;
              }

              _context.next = 9;
              return calendar_service/* calendarApi.deleteCourseFromFavourite */.w.deleteCourseFromFavourite(eventKey);

            case 9:
              _context.next = 13;
              break;

            case 11:
              _context.next = 13;
              return calendar_service/* calendarApi.deleteConferenceFromFavourite */.w.deleteConferenceFromFavourite(eventKey);

            case 13:
              _context.next = 17;
              break;

            case 15:
              _context.next = 17;
              return isCourse ? calendar_service/* calendarApi.addCourseToFavourite */.w.addCourseToFavourite(eventKey) : calendar_service/* calendarApi.addConferenceToFavourite */.w.addConferenceToFavourite(eventKey);

            case 17:
              dispatch((0,ui/* setIsNeedToUpdateFavoriteList */.RH)(true));
              setIsFavourite(!isFavourite);
              _context.next = 24;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](0);
              setHasError(true);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 21]]);
    }));

    return function handleOnFavoriteClick() {
      return _ref2.apply(this, arguments);
    };
  }();

  var getEventPlaceForCourse = function getEventPlaceForCourse() {
    var _event$dates2, _event$dates3, _event$dates3$find, _event$dates3$find$ve;

    var isOnline = !!(event !== null && event !== void 0 && (_event$dates2 = event.dates) !== null && _event$dates2 !== void 0 && _event$dates2.find(function (date) {
      var _date$venues;

      return ((_date$venues = date.venues) === null || _date$venues === void 0 ? void 0 : _date$venues.length) === 0;
    }));
    var venue = event === null || event === void 0 ? void 0 : (_event$dates3 = event.dates) === null || _event$dates3 === void 0 ? void 0 : (_event$dates3$find = _event$dates3.find(function (date) {
      var _date$venues2;

      return ((_date$venues2 = date.venues) === null || _date$venues2 === void 0 ? void 0 : _date$venues2.length) > 0;
    })) === null || _event$dates3$find === void 0 ? void 0 : (_event$dates3$find$ve = _event$dates3$find.venues) === null || _event$dates3$find$ve === void 0 ? void 0 : _event$dates3$find$ve[0];
    return "".concat(venue ? t('event.isPresent') : '').concat(isOnline && venue ? ' | ' : '').concat(isOnline ? t('event.isOnline') : '');
  };

  var getEventPlaceForConference = function getEventPlaceForConference() {
    var _event$dates4, _event$dates5, _event$dates5$find, _event$dates5$find$ve;

    var isOnline = !!(event !== null && event !== void 0 && (_event$dates4 = event.dates) !== null && _event$dates4 !== void 0 && _event$dates4.find(function (date) {
      var _date$venues3;

      return ((_date$venues3 = date.venues) === null || _date$venues3 === void 0 ? void 0 : _date$venues3.length) === 0;
    }));
    var venue = event === null || event === void 0 ? void 0 : (_event$dates5 = event.dates) === null || _event$dates5 === void 0 ? void 0 : (_event$dates5$find = _event$dates5.find(function (date) {
      var _date$venues4;

      return ((_date$venues4 = date.venues) === null || _date$venues4 === void 0 ? void 0 : _date$venues4.length) > 0;
    })) === null || _event$dates5$find === void 0 ? void 0 : (_event$dates5$find$ve = _event$dates5$find.venues) === null || _event$dates5$find$ve === void 0 ? void 0 : _event$dates5$find$ve[0];

    if (isConference) {
      return "".concat(venue ? "".concat(venue.city, ", ").concat(venue.name) : '').concat(isOnline && venue ? ' | ' : '').concat(isOnline ? t('event.isOnline') : '');
    }

    return "".concat(venue ? isConference ? "".concat(venue.city, ", ").concat(venue.name) : t('event.isPresent') : '').concat(isOnline && venue ? ' | ' : '').concat(isOnline ? t('event.isOnline') : '');
  };

  var getEventDateForCourse = function getEventDateForCourse() {
    var _eventDate$date, _eventDate$date2;

    var from = moment_default()(eventDate === null || eventDate === void 0 ? void 0 : (_eventDate$date = eventDate.date) === null || _eventDate$date === void 0 ? void 0 : _eventDate$date.from);
    var to = moment_default()(eventDate === null || eventDate === void 0 ? void 0 : (_eventDate$date2 = eventDate.date) === null || _eventDate$date2 === void 0 ? void 0 : _eventDate$date2.to);
    return to.diff(from, 'days') > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(DateNumber, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        children: [moment_default()(from).format('DD. MM. '), " "]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DateSeparator, {
        children: "-"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        children: [" ", moment_default()(to).format('DD. MM. ')]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "year",
        children: moment_default()(to).format('YYYY')
      }), router.pathname === constants/* ROUTES.HOME */.Z6.HOME && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "label courseLabel",
        children: t('event.trainingType')
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(DateNumber, {
      children: [moment_default()(from).format('DD. MM. YYYY'), router.pathname === constants/* ROUTES.HOME */.Z6.HOME && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "label courseLabel",
        children: t('event.trainingType')
      })]
    });
  };

  var getEventDateForConference = function getEventDateForConference() {
    var _event$dates6, _eventDate$date3, _event$dates7, _eventDate$date4;

    var minDate = (event === null || event === void 0 ? void 0 : (_event$dates6 = event.dates) === null || _event$dates6 === void 0 ? void 0 : _event$dates6.reduce(function (a, b) {
      return a.date.from < b.date.from ? a : b;
    }).date.from) || (eventDate === null || eventDate === void 0 ? void 0 : (_eventDate$date3 = eventDate.date) === null || _eventDate$date3 === void 0 ? void 0 : _eventDate$date3.from);
    var maxDate = (event === null || event === void 0 ? void 0 : (_event$dates7 = event.dates) === null || _event$dates7 === void 0 ? void 0 : _event$dates7.reduce(function (a, b) {
      return a.date.to > b.date.to ? a : b;
    }).date.to) || (eventDate === null || eventDate === void 0 ? void 0 : (_eventDate$date4 = eventDate.date) === null || _eventDate$date4 === void 0 ? void 0 : _eventDate$date4.to);
    var from = moment_default()(minDate);
    var to = moment_default()(maxDate);
    return to.diff(from, 'days') > 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(DateNumber, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        children: [moment_default()(from).format('DD. MM. '), " "]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DateSeparator, {
        children: "-"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        children: [" ", moment_default()(to).format('DD. MM. ')]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "year",
        children: moment_default()(to).format('YYYY')
      }), router.pathname === constants/* ROUTES.HOME */.Z6.HOME && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "label conferenceLabel",
        children: t('event.conferenceType')
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(DateNumber, {
      children: [moment_default()(from).format(minDate && maxDate ? 'DD. MM. YYYY' : 'MM. YYYY'), router.pathname === constants/* ROUTES.HOME */.Z6.HOME && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "label conferenceLabel",
        children: t('event.conferenceType')
      })]
    });
  };

  var buildRedirectPathname = function buildRedirectPathname() {
    if (isCourse) {
      var _event$course3, _event$event4;

      return "".concat(constants/* ROUTES.TRAINING */.Z6.TRAINING, "/").concat(((_event$course3 = event.course) === null || _event$course3 === void 0 ? void 0 : _event$course3.slug) || ((_event$event4 = event.event) === null || _event$event4 === void 0 ? void 0 : _event$event4.slug));
    }

    if (isConference) {
      var _event$conference3, _event$event5;

      return "".concat(constants/* ROUTES.CONFERENCE */.Z6.CONFERENCE, "/").concat(((_event$conference3 = event.conference) === null || _event$conference3 === void 0 ? void 0 : _event$conference3.slug) || ((_event$event5 = event.event) === null || _event$event5 === void 0 ? void 0 : _event$event5.slug));
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
    children: [hasError && /*#__PURE__*/(0,jsx_runtime.jsx)(Alert/* default */.Z, {
      type: Alert/* AlertTypes.error */.d.error,
      message: t('course.popular.error')
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Topic, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TopicFirstRow, {
        children: [isCourse && (eventDate !== null && eventDate !== void 0 && eventDate.date ? getEventDateForCourse() : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})), isConference && (event !== null && event !== void 0 && event.dates ? getEventDateForConference() : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {})), /*#__PURE__*/(0,jsx_runtime.jsxs)(Favourite, {
          hasRecordStatus: false,
          onClick: handleOnFavoriteClick,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FavouriteIcon, {
            name: isFavourite ? Icon/* Icons.FavouriteFull */.PJ.FavouriteFull : Icon/* Icons.Favourite */.PJ.Favourite
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FavouriteLabel, {
            children: isFavourite ? t('course.popular.remove') : t('course.popular.add')
          })]
        })]
      }), ((event === null || event === void 0 ? void 0 : (_event$dates8 = event.dates) === null || _event$dates8 === void 0 ? void 0 : (_event$dates8$find = _event$dates8.find(function (e) {
        return e.online;
      })) === null || _event$dates8$find === void 0 ? void 0 : (_event$dates8$find$mo = _event$dates8$find.modules) === null || _event$dates8$find$mo === void 0 ? void 0 : _event$dates8$find$mo.length) > 0 || (event === null || event === void 0 ? void 0 : (_event$dates9 = event.dates) === null || _event$dates9 === void 0 ? void 0 : (_event$dates9$ = _event$dates9[0]) === null || _event$dates9$ === void 0 ? void 0 : (_event$dates9$$module = _event$dates9$.modules) === null || _event$dates9$$module === void 0 ? void 0 : _event$dates9$$module.length) > 0) && /*#__PURE__*/(0,jsx_runtime.jsx)(TopicPackageRow, {
        children: (_ref3 = (event === null || event === void 0 ? void 0 : (_event$dates10 = event.dates) === null || _event$dates10 === void 0 ? void 0 : _event$dates10.find(function (e) {
          return e.online;
        })) || (event === null || event === void 0 ? void 0 : (_event$dates11 = event.dates) === null || _event$dates11 === void 0 ? void 0 : _event$dates11[0])) === null || _ref3 === void 0 ? void 0 : (_ref3$modules = _ref3.modules) === null || _ref3$modules === void 0 ? void 0 : (_ref3$modules$filter = _ref3$modules.filter(function (module) {
          return constants_packages/* SUBSCRIPTION_PACKAGES_KEYS.includes */.GP.includes(module._key);
        })) === null || _ref3$modules$filter === void 0 ? void 0 : _ref3$modules$filter.map(function (module, key) {
          var subscriptionPackage = constants_packages/* SUBSCRIPTION_PACKAGES.find */.QG.find(function (subPackage) {
            return subPackage.key === module._key;
          });
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Package/* default */.Z, {
            color: subscriptionPackage === null || subscriptionPackage === void 0 ? void 0 : subscriptionPackage.color,
            symbol: subscriptionPackage === null || subscriptionPackage === void 0 ? void 0 : subscriptionPackage.icon
          }, "package-".concat(key));
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TopicSecondRow, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TopicPlace, {
          children: [isCourse && getEventPlaceForCourse(), isConference && getEventPlaceForConference()]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: buildRedirectPathname(),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(TopicTitle, {
            children: ((_event$course4 = event.course) === null || _event$course4 === void 0 ? void 0 : _event$course4.title) || ((_event$conference4 = event.conference) === null || _event$conference4 === void 0 ? void 0 : _event$conference4.title) || (event === null || event === void 0 ? void 0 : (_event$event6 = event.event) === null || _event$event6 === void 0 ? void 0 : _event$event6.title)
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [((_ref4 = (event === null || event === void 0 ? void 0 : event.tags) || (eventDate === null || eventDate === void 0 ? void 0 : eventDate.tags)) === null || _ref4 === void 0 ? void 0 : (_ref4$filter = _ref4.filter(function (tag) {
          return tag === null || tag === void 0 ? void 0 : tag.label;
        })) === null || _ref4$filter === void 0 ? void 0 : _ref4$filter.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(TopicThirdRow, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Lecturers, {
            children: (_ref5 = (eventDate === null || eventDate === void 0 ? void 0 : eventDate.lectors) || (eventDate === null || eventDate === void 0 ? void 0 : eventDate.people) || (event === null || event === void 0 ? void 0 : (_event$dates12 = event.dates) === null || _event$dates12 === void 0 ? void 0 : (_event$dates12$ = _event$dates12[0]) === null || _event$dates12$ === void 0 ? void 0 : _event$dates12$.people)) === null || _ref5 === void 0 ? void 0 : _ref5.map(function (person, key) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Lecturer/* default */.Z, {
                image: person !== null && person !== void 0 && person.photo ? "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/people/").concat(person === null || person === void 0 ? void 0 : person.photo) : "".concat((0,url_utils/* publicAssets */.VK)('/avatar.svg')),
                name: (0,person_utils/* formatLecturerName */.v)(person),
                slug: person === null || person === void 0 ? void 0 : person.slug
              }, "lecturer-".concat(key));
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TopicThirdRow, {
          children: [((_ref6 = (event === null || event === void 0 ? void 0 : event.tags) || (eventDate === null || eventDate === void 0 ? void 0 : eventDate.tags)) === null || _ref6 === void 0 ? void 0 : (_ref6$filter = _ref6.filter(function (tag) {
            return tag === null || tag === void 0 ? void 0 : tag.label;
          })) === null || _ref6$filter === void 0 ? void 0 : _ref6$filter.length) > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(Tags, {
            children: (_ref7 = (event === null || event === void 0 ? void 0 : event.tags) || (eventDate === null || eventDate === void 0 ? void 0 : eventDate.tags)) === null || _ref7 === void 0 ? void 0 : (_ref7$filter = _ref7.filter(function (tag) {
              return tag.label;
            })) === null || _ref7$filter === void 0 ? void 0 : _ref7$filter.map(function (tag, key) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag/* default */.Z, {
                name: tag.title,
                color: tag.color
              }, "tag-".concat(key));
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Lecturers, {
            children: (_ref8 = (eventDate === null || eventDate === void 0 ? void 0 : eventDate.lectors) || (eventDate === null || eventDate === void 0 ? void 0 : eventDate.people) || (event === null || event === void 0 ? void 0 : (_event$dates13 = event.dates) === null || _event$dates13 === void 0 ? void 0 : (_event$dates13$ = _event$dates13[0]) === null || _event$dates13$ === void 0 ? void 0 : _event$dates13$.people)) === null || _ref8 === void 0 ? void 0 : _ref8.map(function (person, key) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Lecturer/* default */.Z, {
                image: person !== null && person !== void 0 && person.photo ? "".concat((0,constants/* getImageBaseURL */.P9)(), "/media/people/").concat(person === null || person === void 0 ? void 0 : person.photo) : "".concat((0,url_utils/* publicAssets */.VK)('/avatar.svg')),
                name: (0,person_utils/* formatLecturerName */.v)(person),
                slug: person === null || person === void 0 ? void 0 : person.slug
              }, "lecturer-".concat(key));
            })
          }), !router.asPath.includes(constants/* ROUTES.MY_PV_MATERIALS */.Z6.MY_PV_MATERIALS) && /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            marginTop: 10,
            onClick: function onClick() {
              return router.push({
                pathname: buildRedirectPathname()
              });
            },
            whiteType: true,
            text: t('homepage.calendar.button.detail'),
            noWrap: true
          })]
        })]
      }), (eventDate === null || eventDate === void 0 ? void 0 : (_eventDate$attachment = eventDate.attachments) === null || _eventDate$attachment === void 0 ? void 0 : _eventDate$attachment.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(MyMaterials, {
        materials: eventDate === null || eventDate === void 0 ? void 0 : eventDate.attachments,
        eventSlug: ((_event$course5 = event.course) === null || _event$course5 === void 0 ? void 0 : _event$course5.slug) || ((_event$conference5 = event.conference) === null || _event$conference5 === void 0 ? void 0 : _event$conference5.slug) || (event === null || event === void 0 ? void 0 : (_event$event7 = event.event) === null || _event$event7 === void 0 ? void 0 : _event$event7.slug)
      })]
    })]
  }, iKey);
};

/* harmony default export */ var Event = (EventTemplate);

/***/ }),

/***/ 31828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GP": function() { return /* binding */ SUBSCRIPTION_PACKAGES_KEYS; },
/* harmony export */   "QG": function() { return /* binding */ SUBSCRIPTION_PACKAGES; }
/* harmony export */ });
/* unused harmony export SUBSCRIPTION_PACKAGES_KEYS_ENUM */
var SUBSCRIPTION_PACKAGES = [{
  title: 'Daně a účetnictví',
  key: 'taxes',
  moduleId: 'taxes',
  color: '#F2941A',
  saleBoxBackground: '#FAEFE1',
  redirectLink: 'https://studiow.cz/kurzy?kurz_typ=aktualne&rocni_predplatne=taxes',
  icon: 'D',
  benefits: ['<span class="bold">80+</span> nových webinářů každý rok', '<span class="bold">TOP lektoři</span> zodpovídají vaše dotazy', 'Archiv všech <span class="bold">videozáznamů</span>', '<span class="bold">Školicí materiály</span> ke stažení', '1 licence <span class="bold">pro 5 osob</span>', 'Exkluzivní webináře navíc'],
  price: '14 157',
  priceWithoutVat: '11 700'
}, {
  title: 'Mzdy, pracovní právo a personalistika',
  key: 'wages',
  moduleId: 'wages',
  color: '#F00035',
  saleBoxBackground: '#F7DADA',
  redirectLink: 'https://studiow.cz/kurzy?kurz_typ=aktualne&rocni_predplatne=wages',
  icon: 'M',
  benefits: ['<span class="bold">80+</span> nových webinářů každý rok', '<span class="bold">TOP lektoři</span> zodpovídají vaše dotazy', 'Archiv všech <span class="bold">videozáznamů</span>', '<span class="bold">Školicí materiály</span> ke stažení', '1 licence <span class="bold">pro 5 osob</span>', 'Exkluzivní webináře navíc'],
  price: '14 157',
  priceWithoutVat: '11 700'
}, {
  title: 'Veřejná správa',
  key: 'government',
  moduleId: 'government',
  color: '#63BF4D',
  saleBoxBackground: '#E7F5E4',
  redirectLink: 'https://studiow.cz/kurzy?kurz_typ=aktualne&rocni_predplatne=government',
  icon: 'V',
  benefits: ['<span class="bold">30+</span> nových webinářů každý rok', '<span class="bold">TOP lektoři</span> zodpovídají vaše dotazy', 'Archiv všech <span class="bold">videozáznamů</span>', '<span class="bold">Školicí materiály</span> ke stažení', '1 licence <span class="bold">pro 5 osob</span>', 'Exkluzivní webináře navíc'],
  price: '8 349',
  priceWithoutVat: '6 900'
}];
var SUBSCRIPTION_PACKAGES_KEYS = ['taxes', 'wages', 'government'];
var SUBSCRIPTION_PACKAGES_KEYS_ENUM = {
  TAXES: 'taxes',
  WAGES: 'wages',
  GOVERNMENT: 'government'
};

/***/ }),

/***/ 58596:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Lecturer; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(40238);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
;// CONCATENATED MODULE: ./src/ui/Lecturer/Lecturer.elements.tsx



var Wrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Lecturerelements__Wrapper",
  componentId: "sc-1urcrvf-0"
})(["display:inline-flex;align-items:center;margin-right:", ";margin-bottom:", ";cursor:pointer;"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(10));
var ImageSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Lecturerelements__ImageSection",
  componentId: "sc-1urcrvf-1"
})(["position:relative;width:", ";height:", ";overflow:hidden;border-radius:50%;margin-right:", ";margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(32), (0,polished_esm/* rem */.hO)(32), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(2));
var Photo = (0,styled_components_browser_esm/* default */.ZP)((image_default())).withConfig({
  displayName: "Lecturerelements__Photo",
  componentId: "sc-1urcrvf-2"
})(["position:absolute;left:50%;top:50%;width:100%;height:auto;transform:translate(-50%,-50%);"]);
var Title = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Lecturerelements__Title",
  componentId: "sc-1urcrvf-3"
})(["font-weight:", ";color:", ";"], function (prop) {
  return prop.isBold ? prop.theme.fontWeights.textBold : prop.theme.fontWeights.textRegular;
}, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.grey;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Lecturer/Lecturer.tsx







var LecturerTemplate = function LecturerTemplate(_ref) {
  var image = _ref.image,
      isBold = _ref.isBold,
      name = _ref.name,
      slug = _ref.slug;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    onClick: function onClick() {
      return slug && router.push({
        pathname: "".concat(constants/* ROUTES.LECTURER */.Z6.LECTURER, "/").concat(slug)
      });
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageSection, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Photo, {
        src: image,
        width: 0,
        height: 0,
        alt: name,
        loader: function loader(_ref2) {
          var src = _ref2.src;
          return src;
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      children: name
    })]
  });
};

/* harmony default export */ var Lecturer = (LecturerTemplate);

/***/ }),

/***/ 42420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Package; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
;// CONCATENATED MODULE: ./src/ui/Package/Package.elements.tsx


var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Packageelements__Wrapper",
  componentId: "sc-1xcvnya-0"
})(["display:inline-flex;width:", ";min-width:", ";height:", ";background:", ";align-items:center;justify-content:center;border-radius:", ";color:", ";font-weight:", ";font-size:", ";margin:0 ", " 0 ", ";"], (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(30), (0,polished_esm/* rem */.hO)(22), function (props) {
  return props.background;
}, (0,polished_esm/* rem */.hO)(24), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textRegular;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes.textSmall;
}, (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(5));
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Package/Package.tsx





var PackageTemplate = function PackageTemplate(_ref) {
  var symbol = _ref.symbol,
      color = _ref.color;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    background: color,
    children: symbol
  });
};

/* harmony default export */ var Package = (PackageTemplate);

/***/ }),

/***/ 67279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Tag; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(41686);
;// CONCATENATED MODULE: ./src/ui/Tag/Tag.elements.tsx


var Wrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "Tagelements__Wrapper",
  componentId: "sc-1w7pdns-0"
})(["", ";", ";padding:", " ", ";margin-right:", ";margin-bottom:", ";border-radius:", ";text-transform:uppercase;font-size:", ";display:inline-block;"], function (prop) {
  return "color: ".concat(prop.color ? prop.color : prop.theme.colors.black);
}, function (prop) {
  return "border: 1px solid ".concat(prop.color ? prop.color : prop.theme.colors.black);
}, (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(4), function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.textSmall;
});
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/ui/Tag/Tag.tsx




var TagTemplate = function TagTemplate(_ref) {
  var color = _ref.color,
      name = _ref.name;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
    color: color,
    children: name
  });
};

/* harmony default export */ var Tag = (TagTemplate);

/***/ }),

/***/ 27098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ handleDownloadClick; },
/* harmony export */   "h": function() { return /* binding */ handleDownloadClickAsZip; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93162);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(file_saver__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55733);
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(jszip__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40238);






var zip = new (jszip__WEBPACK_IMPORTED_MODULE_3___default())();
var handleDownloadClick = /*#__PURE__*/function () {
  var _ref = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(key, name, isCatalogDownload, type) {
    var _link, originalImage, _link2, image, imageBlog, imageURL, link;

    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!isCatalogDownload) {
              _context.next = 7;
              break;
            }

            _link = document.createElement('a');

            _link.setAttribute('target', '_blank');

            _link.href = (0,_constants__WEBPACK_IMPORTED_MODULE_4__/* .getCatalogUrl */ .pW)();
            _link.download = name;

            _link.dispatchEvent(new MouseEvent('click'));

            return _context.abrupt("return");

          case 7:
            originalImage = "".concat((0,_constants__WEBPACK_IMPORTED_MODULE_4__/* .getApiURL */ .tU)(), "/media/attachments/").concat(key);

            if (!(type === 'application/pdf')) {
              _context.next = 14;
              break;
            }

            _link2 = document.createElement('a');
            _link2.href = originalImage;
            _link2.download = 'file.pdf';

            _link2.dispatchEvent(new MouseEvent('click'));

            return _context.abrupt("return");

          case 14:
            _context.next = 16;
            return fetch(originalImage);

          case 16:
            image = _context.sent;
            _context.next = 19;
            return image.blob();

          case 19:
            imageBlog = _context.sent;
            imageURL = URL.createObjectURL(imageBlog);
            link = document.createElement('a');
            link.href = imageURL;
            link.download = name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function handleDownloadClick(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
var handleDownloadClickAsZip = /*#__PURE__*/function () {
  var _ref2 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(materials, eventSlug) {
    var formattedFiles, arrOfFiles;
    return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            formattedFiles = materials.map(function (material) {
              return {
                url: "".concat((0,_constants__WEBPACK_IMPORTED_MODULE_4__/* .getApiURL */ .tU)(), "/media/attachments/").concat(material._key),
                name: "".concat(material.name).concat(getFileSuffixByMimeType(material.mime_type))
              };
            });
            arrOfFiles = formattedFiles.map(function (item) {
              return axios__WEBPACK_IMPORTED_MODULE_1___default().get(item.url, {
                responseType: 'blob'
              }).then(function (resp) {
                zip.file(item.name, resp.data);
              });
            });
            return _context2.abrupt("return", Promise.all(arrOfFiles).then(function () {
              zip.generateAsync({
                type: 'blob'
              }).then(function (blob) {
                (0,file_saver__WEBPACK_IMPORTED_MODULE_2__.saveAs)(blob, "".concat(eventSlug, ".zip"));
              });
            })["catch"](function (err) {
              console.log(err);
            }));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function handleDownloadClickAsZip(_x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

var getFileSuffixByMimeType = function getFileSuffixByMimeType(mimeType) {
  switch (mimeType) {
    case 'application/pdf':
      return '.pdf';

    case 'image/jpeg':
      return '.jpeg';

    case 'image/png ':
      return '.png';

    case 'text/plain':
      return '.txt';

    default:
      return '';
  }
};

/***/ }),

/***/ 19033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ formatLecturerName; }
/* harmony export */ });
var formatLecturerName = function formatLecturerName(person) {
  if (!person) return;
  return "".concat(person.titles.before_name ? "".concat(person.titles.before_name, " ") : '').concat(person.name, " ").concat(person.surname).concat(person.titles.after_name ? " ".concat(person.titles.after_name) : '');
};

/***/ })

}]);